import React from "react";
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel } from "@material-ui/core";

const CheckBoxComponent = ({
  name,
  label,
  value,
  handleChange,
  heading,
  labelPosition,
  checkBoxType,
}) => {
  return (
    // <FormControlLabel
    //   control={<Checkbox onChange={handleChange} name={name} checked={value} color="primary" />}
    //   label={label}
    //   labelPlacement={labelPosition}
    // />
    <FormControl fullWidth component="fieldset" margin="normal">
      <FormLabel component="legend" focused={false}>
        {heading}
      </FormLabel>
      {checkBoxType === "single" || !checkBoxType ? (
        <FormControlLabel
          control={
            <Checkbox onChange={handleChange} name={name} checked={value} style={{ color: "#0166A4" }} />
          }
          label={label}
          labelPlacement={labelPosition}
        />
      ) : (
        <FormGroup row={true}>
          {label.map((item, i) => (
            <FormControlLabel
              key={item}
              value={value}
              labelPlacement={labelPosition}
              control={
                <Checkbox
                  value={item}
                  checked={value && value.indexOf(item) > -1}
                  onChange={handleChange}
                  name={name}
                  style={{ color: "#0166A4" }}
                />
              }
              label={item}
            />
          ))}
        </FormGroup>
      )}
    </FormControl>
  );
};

export default CheckBoxComponent;

CheckBoxComponent.defaultProps = {
  labelPosition: "end",
};
